import store from '../store/index'
import { Message } from 'element-ui'

var constant = {
  getToken () {
    let storeToken = store.state.loginInfo.toke
    let localStorageToken = sessionStorage.getItem('token')
    let token = localStorageToken || storeToken
    return token
  },
  getUserType () {
    let storeUserType = store.state.loginInfo.userType
    let localStorageUserType = sessionStorage.getItem('userType')
    let userType = localStorageUserType || storeUserType
    return userType
  },
  giveMessage (msg, type) {
    Message({
      showClose: true,
      message: msg,
      type: type
    })
  },
  pathPre: '/wtapi/dayee'
}
export default constant



// WEBPACK FOOTER //
// ./src/utils/constant.js